import React from "react";
const Preset7 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M28 24C28 21.7909 29.7909 20 32 20H80C82.2091 20 84 21.7909 84 24V88C84 90.2091 82.2091 92 80 92H32C29.7909 92 28 90.2091 28 88V24Z",
        fill: "#E9F0FF"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M28 24C28 21.7909 29.7909 20 32 20H80C82.2091 20 84 21.7909 84 24V59H28V24Z",
        fill: "url(#paint0_linear_6001_4920)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "33", y: "24", width: "20", height: "6", rx: "3", fill: "#000624" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M38.4468 43.9303L28 51.2857V57C28 58.1046 28.8954 59 30 59H82C83.1046 59 84 58.1046 84 57V47L72.9445 39.216C71.9086 38.4867 70.5262 38.4867 69.4903 39.216L52.3478 51.2857L41.901 43.9303C40.8651 43.2009 39.4827 43.2009 38.4468 43.9303Z",
        fill: "url(#paint1_linear_6001_4920)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "80", width: "48", height: "8", rx: "2", fill: "#116DFF" }),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "65", width: "48", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "71", width: "3", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("rect", { x: "36", y: "71", width: "9", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("circle", { cx: "47", cy: "37", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4920",
        x1: "56",
        y1: "20",
        x2: "56",
        y2: "59",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4920",
        x1: "56",
        y1: "38",
        x2: "56",
        y2: "59",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset7
};
//# sourceMappingURL=Preset7.js.map
